export enum LocalStorageKeys {
  SESSION_TIMER_KEY = 'session-timer',
  QUOTE_PRICE_DISPLAY_MONTHLY = 'quote-price-display-monthly',
}
